const env = process.env.REACT_APP_ENV ;
const envConfig = {
  ENV: env,
  API_URL: process.env.REACT_APP_API_URL || '',
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI?.trim() || '',
  WORDPRESS_API_URL: "https://usapath.azurewebsites.net/api/getAllFaq.php",
};

export default envConfig;
